import { useState, useEffect } from 'react'
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export function useError() {
  const [error, setError] = useState()
  if (error) {
    throw error
  }

  return setError
}

export function useBrowserLocation() {
  const [location, setLocation] = useState()

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      ({ coords: { latitude, longitude } }) =>
        setLocation([latitude, longitude])
    )
  }, [setLocation])

  return location
}

// hooks/useIncidentStatus.js

export const useIncidentStatus = (channelData) => {

  const [incidentStatus, setIncidentStatus] = useState(null);
  useEffect(() => {
    const fetchIncidentStatus = async () => {
      if (channelData?.chatType === 'incident' && channelData?.incidentId) {
        const incidentRef = doc(db, 'incidents', channelData.incidentId);
        const incidentSnap = await getDoc(incidentRef);
        if (incidentSnap.exists()) {
          setIncidentStatus(incidentSnap.data().status);
        }
      }
    };

    fetchIncidentStatus();
  }, [channelData]);

  return {
    isIncident: channelData?.chatType === 'incident',
    isIncidentActive: incidentStatus && incidentStatus !== 'ended',
    incidentStatus
  };
};
export function parseARGB(hex) {
  if (!hex) return { color: "#000000", opacity: 1 };

  // 8-digit hex (ARGB)
  if (hex.length === 9) {
    const alpha = parseInt(hex.substring(1, 3), 16) / 255;
    const color = "#" + hex.substring(3);
    return { color, opacity: alpha };
  }

  // 6-digit hex
  if (hex.length === 7) {
    return { color: hex, opacity: 1 };
  }

  return { color: "#000000", opacity: 1 };
}
